import {
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ApirestService } from '../apirest.service';
import { VoiceRecorder } from 'capacitor-voice-recorder';
import { Capacitor } from '@capacitor/core';
import { ChangeDetectorRef } from '@angular/core';
import { ChatService } from '../chatService.service';

@Component({
  selector: 'app-chat-bubble',
  templateUrl: './chat-bubble.page.html',
  styleUrls: ['./chat-bubble.page.scss'],
})
export class ChatBubblePage implements OnInit, OnDestroy {
  @ViewChild('fileInput') fileInputRef: ElementRef;
  @ViewChild('chatContent', { read: ElementRef }) chatContent!: ElementRef;
  @ViewChild('fab', { read: ElementRef })
  fabRef!: ElementRef<HTMLElement>;

  fabPosition = { x: window.innerWidth - 80, y: window.innerHeight - 120 }; // posición inicial (esquina inferior derecha)
  private dragging = false;
  private offset = { x: 0, y: 0 };

  private startX = 0;
  private startY = 0;
  isOpen = false;
  showChat = true;
  public isFieldsFilled = false;
  private rafId: number | null = null;
  private pendingX = 0;
  private pendingY = 0;
  private moved = false;
  private dragThreshold = 5; // px
  private downX = 0;
  private downY = 0;
  private firstMove = true;
  private maxX = 0;
  private maxY = 0;
  private margin = 20;
  private fabSize = 60;

  data = {
    sessionId: '',
    message: '',
    files: [],
    dryRun: false,
  };
  //messages: { role: 'user' | 'assistant'; content: string }[] = [];
  messages: {
    role: 'user' | 'assistant';
    content: string;
    loading?: boolean;
  }[] = [];

  isRecording = false;

  mediaRecorder: MediaRecorder;
  chunks: BlobPart[] = [];
  audioUrl: string | null = null;
  public files: any = [];
  loading = false;
  isDesktop: boolean;

  constructor(
    public service: ApirestService,
    private cdr: ChangeDetectorRef,
    private chatService: ChatService,
    private renderer: Renderer2,
    private ngZone: NgZone,
  ) {}

  ngOnInit() {
    this.chatService.isOpen$.subscribe((open) => (this.isOpen = open));
    this.messages.push({
      role: 'assistant',
      content: `👋 Hi, I'm here to help.
                Click the chat icon to start the conversation.`,
    });

    const saved = localStorage.getItem('chatPosition');
    //if (saved) this.fabPosition = JSON.parse(saved);
    if (saved) {
      this.fabPosition = JSON.parse(saved);
    } else {
      // esperar a que ion-app tenga tamaño real
      //setTimeout(() => this.initFabPosition());
    }
  }

  ngAfterViewInit() {
    setTimeout(() => this.initFabPosition());
  }

  ngOnDestroy() {
    this.dragging = false;
  }

  toggleChat() {
    //this.getSessionId();
    if (this.data.sessionId !== '') {
      this.isOpen = !this.isOpen;
    } else {
      this.getSessionId();
    }
  }

  getSessionId() {
    this.service.queryPost('openai/chat/session', {}).subscribe((res: any) => {
      console.log('res', res);
      this.data.sessionId = res.sessionId;
      this.isOpen = true;
    });
  }

  async send() {
    if (this.files.length > 0) {
      await this.uploadFile();
    }

    if (!this.data.message.trim()) return;

    this.loading = true;
    this.messages.push({ role: 'user', content: this.data.message });
    this.cdr.detectChanges();
    //setTimeout(() => this.scrollToBottom(), 0);

    // Mostrar mensaje temporal del asistente
    this.messages.push({
      role: 'assistant',
      content: '...',
      loading: true,
    });
    this.cdr.detectChanges();
    setTimeout(() => this.scrollToBottom(), 0);

    this.service.queryPost('openai/chat', this.data).subscribe(
      (response: any) => {
        this.data.message = '';
        let result = response;
        console.log('result', result);

        this.loading = false;
        this.data.sessionId = result.sessionId;

        // Quitar el mensaje "..." y reemplazarlo por el real
        const lastIndex = this.messages.findIndex((m) => m.loading);
        if (lastIndex !== -1) this.messages.splice(lastIndex, 1);

        this.messages.push({
          role: 'assistant',
          content: result.message.content,
        });

        this.data.files = [];
        this.cdr.detectChanges();
        //setTimeout(() => this.scrollToBottom(), 0);
      },
      (error) => {
        console.error(error);
        this.loading = false;

        // Si falla, también eliminamos el "..."
        const lastIndex = this.messages.findIndex((m) => m.loading);
        if (lastIndex !== -1) this.messages.splice(lastIndex, 1);

        this.messages.push({
          role: 'assistant',
          content: ' Ocurrió un error al procesar tu mensaje.',
        });
        this.cdr.detectChanges();
        setTimeout(() => this.scrollToBottom(), 0);
      },
    );
  }

  /* send() {
    if (!this.data.message.trim() && this.files.length === 0) return;

    this.messages.push({ role: 'user', content: this.data.message });
    this.cdr.detectChanges();

    const formData = new FormData();
    formData.append('sessionId', this.data.sessionId);
    formData.append('message', this.data.message);

    if (this.files > 0) {
      this.files.forEach((file, index) => {
        formData.append('files', file);
      });
    }

    this.service
      .queryPost('openai/chat', formData)
      .subscribe((response: any) => {
        console.log('response', response);
        this.data.sessionId = response.sessionId;

        this.messages.push({
          role: 'assistant',
          content: response.message.content,
        });

        this.data.message = '';
        this.files = []; // limpiar después de enviar
        this.cdr.detectChanges();
      });
  } */

  checkFields() {
    this.isFieldsFilled =
      this.data.message && this.data.message.trim().length > 0;
  }

  recordAudio() {
    if (Capacitor.getPlatform() === 'web') {
      this.startRecordingWeb();
    } else {
      this.startRecordingMobile();
    }
  }

  stopRecording() {
    if (Capacitor.getPlatform() === 'web') {
      this.stopRecordingWeb();
    } else {
      this.stopRecordingMobile();
    }
  }

  async startRecordingMobile() {
    const perm = await VoiceRecorder.hasAudioRecordingPermission();
    if (!perm.value) await VoiceRecorder.requestAudioRecordingPermission();

    await VoiceRecorder.startRecording();
    this.isRecording = true;
  }

  async stopRecordingMobile() {
    const result: any = await VoiceRecorder.stopRecording();
    this.isRecording = false;

    if (result.value && result.value.recordDataBase64) {
      const base64 = result.value.recordDataBase64;
      const mimeType = result.value.mimeType || 'audio/webm';

      const blob = this.base64ToBlob(base64, mimeType);
      const file = new File([blob], 'recording.webm', { type: mimeType });

      this.sendAudio(file);
    }
  }

  private base64ToBlob(b64Data: string, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  async startRecordingWeb() {
    console.log('ingreso a web');
    this.isRecording = true;
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.mediaRecorder = new MediaRecorder(stream);
    this.chunks = [];
    this.mediaRecorder.ondataavailable = (e) => {
      if (e.data.size > 0) this.chunks.push(e.data);
    };
    this.mediaRecorder.start();
  }

  stopRecordingWeb() {
    this.isRecording = false;
    return new Promise<void>((resolve) => {
      this.mediaRecorder.onstop = async () => {
        const blob = new Blob(this.chunks, { type: 'audio/webm' });
        const file = new File([blob], 'recording.webm', { type: 'audio/webm' });
        this.sendAudio(file);

        this.mediaRecorder.stream.getTracks().forEach((track) => track.stop());
        resolve();
      };
      this.mediaRecorder.stop();
    });
  }

  private sendAudio(file: File) {
    const fd = new FormData();
    fd.append('files', file);

    this.service
      .queryPostImg('openai/chat/audio', fd)
      .subscribe((response: any) => {
        let result = response;
        console.log('result', result);
        this.data.message = result.transcript;
        this.send();
      });
  }

  selectFile() {
    this.fileInputRef.nativeElement.click();
  }

  captureFile(event: any) {
    const original_file: File = event.target.files[0];

    if (!original_file) return;

    const timestamp = Date.now();
    const new_name = `${timestamp}-${original_file.name}`;

    const file = new File([original_file], new_name, {
      type: original_file.type,
      lastModified: original_file.lastModified,
    });

    let nameFile = file.name;
    console.log('nameFile:', nameFile);
    this.files.push(file);
    this.data.files.push(nameFile);
  }

  async uploadFile(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      try {
        const dataForm = new FormData();
        //dataForm.append("service_id", service);

        if (this.files.length > 0) {
          for (let i = 0; i < this.files.length; i++) {
            dataForm.append('files', this.files[i]);
          }
        } else {
          console.log('No se han seleccionado archivos para cargar.');
          resolve();
          return;
        }

        this.service.queryPostImg('openai/uploadfiles', dataForm).subscribe(
          (res) => {
            console.log('Respuesta del servidor', res);
            //this.loading = false;
            //this.data.file = res.data;
            this.files = [];
            resolve();
          },
          (error) => {
            console.error('Error al cargar las imágenes', error);
            reject(error);
            //this.loading = false;
          },
        );
      } catch (e) {
        console.error('ERROR', e);
        reject(e);
        //this.loading = false;
      }
    });
  }

  private scrollToBottom() {
    Promise.resolve().then(() => {
      const el = this.chatContent?.nativeElement;
      if (el) {
        el.scrollTop = el.scrollHeight;
      } else {
      }
    });
  }
  /* private scrollToBottom() {
      Promise.resolve().then(() => {
        const el = this.chatContent?.nativeElement;
        if (el && this.messages.length > 0) {
          // Obtener el último mensaje
          const lastMessageId = `message-${this.messages.length - 1}`;
          const lastMessageElement = document.getElementById(lastMessageId);
          
          if (lastMessageElement) {
            // Hacer scroll al inicio del último mensaje
            const messagePosition = lastMessageElement.offsetTop;
            el.scrollTop = messagePosition;
          } else {
            // Fallback: scroll al final
            el.scrollTop = el.scrollHeight;
          }
        }
      });
    } */

  onPointerDown(event: PointerEvent) {
    this.onPointerDownInternal(event, this.fabRef.nativeElement);
  }

  onPointerDownInternal(event: PointerEvent, fabEl: HTMLElement) {
    event.preventDefault();

    fabEl.setPointerCapture(event.pointerId);

    this.dragging = true;
    this.firstMove = true;
    this.moved = false;
    this.downX = event.clientX;
    this.downY = event.clientY;

    this.startX = event.clientX - this.fabPosition.x;
    this.startY = event.clientY - this.fabPosition.y;

    this.maxX = window.innerWidth - this.fabSize;
    this.maxY = window.innerHeight - this.fabSize;

    this.ngZone.runOutsideAngular(() => {
      fabEl.onpointermove = (e) => this.onPointerMove(e, fabEl);
      fabEl.onpointerup = () => this.onPointerUpEnd(fabEl, event.pointerId);
      fabEl.onpointercancel = () => this.onPointerUpEnd(fabEl, event.pointerId);
    });
  }

  onPointerMove(event: PointerEvent, fabEl: HTMLElement) {
    if (!this.dragging) return;

    const dx = Math.abs(event.clientX - this.downX);
    const dy = Math.abs(event.clientY - this.downY);

    if (dx > this.dragThreshold || dy > this.dragThreshold) {
      this.moved = true;
    }

    if (!this.moved) return; // aún es tap

    const x = event.clientX - this.startX;
    const y = event.clientY - this.startY;

    if (this.firstMove) {
      this.applyTransform(fabEl, x, y);
      this.firstMove = false;
      return;
    }

    this.pendingX = x;
    this.pendingY = y;

    if (this.rafId === null) {
      this.rafId = requestAnimationFrame(() => {
        this.applyTransform(fabEl, this.pendingX, this.pendingY);
        this.rafId = null;
      });
    }
  }

  applyTransform(el: HTMLElement, x: number, y: number) {
    const clampedX = Math.min(Math.max(x, this.margin), this.maxX);
    const clampedY = Math.min(Math.max(y, this.margin), this.maxY);

    el.style.transform = `translate3d(${clampedX}px, ${clampedY}px, 0)`;

    this.fabPosition.x = clampedX;
    this.fabPosition.y = clampedY;
  }

  onPointerUpEnd(fabEl: HTMLElement, pointerId: number) {
    this.dragging = false;

    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    fabEl.releasePointerCapture(pointerId);

    fabEl.onpointermove = null;
    fabEl.onpointerup = null;
    fabEl.onpointercancel = null;

    if (!this.moved) {
      // 👉 fue click / tap
      this.ngZone.run(() => {
        this.toggleChat();
      });
      return;
    }

    this.ngZone.run(() => {
      localStorage.setItem('chatPosition', JSON.stringify(this.fabPosition));
    });
  }

  initFabPosition() {
    const container = this.getFabContainer();
    const rect = container.getBoundingClientRect();

    const size = 60;
    const margin = 20;

    this.fabPosition = {
      x: rect.width - size - margin,
      y: rect.height - size - margin,
    };

    this.adjustFabForDesktop(rect, size);
  }

  getFabContainer() {
    const isDesktop = window.matchMedia(
      '(min-width: 1025px) and (min-height: 769px)',
    ).matches;

    return isDesktop
      ? (document.querySelector('ion-app') as HTMLElement)
      : document.body;
  }

  @HostListener('window:resize')
  onResize() {
    if (this.dragging) return;
    console.log('resize initFabPosition');

    this.initFabPosition();
  }

  adjustFabForDesktop(rect: any, fabSize: any) {
    const isDesktop = window.matchMedia('(min-width: 1025px)').matches;

    if (isDesktop) {
      //console.log('desktop');
      //this.fabPosition.x -= 400;
      this.fabPosition.x = this.getCenterX(rect.width, fabSize) + 150;
      const fabEl = this.fabRef.nativeElement;
      const x = this.fabPosition.x;
      const y = this.fabPosition.y;

      requestAnimationFrame(() => {
        fabEl.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      });
    } else {
      const fabEl = this.fabRef.nativeElement;

      const fabRect = fabEl.getBoundingClientRect();
      this.fabSize = fabRect.width || 60;

      const x = window.innerWidth - this.fabSize - this.margin;
      const y = window.innerHeight - this.fabSize - this.margin;

      this.fabPosition = { x, y };

      requestAnimationFrame(() => {
        fabEl.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      });
    }
  }

  getCenterX(containerWidth: number, fabSize: number): number {
    return containerWidth / 2 - fabSize / 2;
  }
}
